import gamesClient from "../middleware/gamesClient";
import { buildApiUrl } from "../../config";

/**
 * Launch a game / product lobby (provider SSO).
 * POST api/v1/games/launch — always sends the full swagger body;
 * only prd_id is required, the rest default to 0 / "".
 *   prd_type / game_type 0 = auto-detect
 *   game_id  — slots / mini games
 *   table_id — direct live-table launch
 * Response: { success, data: { url | launch_url, session_id, status } }
 */
export async function launchGameRequest({
  prdId,
  gameId,
  tableId,
  category,
  isMobile,
  homeUrl,
}) {
  const body = {
    prd_id: Number(prdId),
    prd_type: 0,
    is_mobile: Boolean(isMobile),
    game_id: gameId ? Number(gameId) : 0,
    game_type: 0,
    table_id: tableId || "",
    category: category || "",
    home_url: homeUrl || "",
  };

  const response = await gamesClient.post("launch", body);
  return response.data;
}

/**
 * Launch the sports book (provider SSO) for the logged-in player.
 * POST api/v1/sports/launch — no body; the player comes from the token.
 * Lives under /sports, not /games, so it passes an absolute URL and
 * gamesClient still adds X-App-Id + Authorization.
 * Response carries launchURL (top level or under data).
 */
export async function launchSportsRequest() {
  const response = await gamesClient.post(
    buildApiUrl("api/v1/sports/launch")
  );
  return response.data;
}
